// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConditionalRevealController from "./conditional_reveal_controller"
application.register("conditional-reveal", ConditionalRevealController)

import DocxController from "./docx_controller"
application.register("docx", DocxController)
